// @flow

import {
  getActivePdbId,
  getPackages as getPdbPackages,
} from '../../../pdb/selectors';
import {
  getReducer,
} from './main';
import type { ActivesState as State } from '../types';
import type { State as ConfigState } from '../../types';
import type { State as PdbState } from '../../../pdb/types';
import type { OrderFormState } from '../../../orderForm/types';
import type { Package, PackageCar } from '../../../../types/pdb';
import type { State as RouterState } from '../../../router/types';

type GlobalState = {
  configuration: ConfigState,
  pdb: PdbState,
  orderForm: OrderFormState,
  router: RouterState,
};

/**
 * We export the function to get all packages for a car here, since we do that for
 * all actives. The reason is that some car properties depend on choices of other
 * car properties.
 */
export const getPackages = (state: GlobalState, pdbId?: ?string): Array<Package> => (
  getPdbPackages(state, pdbId)
);

type ActiveCarPackage = $PropertyType<State, 'activeCarPackage'>;
export const getPackageFromActives = (state: GlobalState, pdbId?: ?string) => {
  const selectedPdbId = pdbId || getActivePdbId(state);
  const carPackage: ActiveCarPackage = getReducer(state).activeCarPackage;
  return carPackage[selectedPdbId] || null;
};

type PackageId = $PropertyType<Package, 'id'>;
export const getActivePackageId = (state: GlobalState, pdbId?: ?string): ?PackageId => {
  const value = getPackageFromActives(state, pdbId);
  return typeof value === 'number' ? value : null;
};

export const getActivePackage = (state: GlobalState, pdbId?: ?string): ?Package => {
  const selectedPdbId = pdbId || getActivePdbId(state);
  const packages = getPackages(state, selectedPdbId);
  const active = getActivePackageId(state, selectedPdbId);
  return (packages && active) ? packages.find(x => x.id === active) : null;
};

export const getPowerFromActivePackage = (state: GlobalState): string => {
  const activePackage = getActivePackage(state);
  if (activePackage) {
    return activePackage.power || '';
  }
  return '';
};

export const getEngineFromActivePackage = (state: GlobalState): string => {
  const activePackage = getActivePackage(state);
  if (activePackage) {
    return activePackage.engine || '';
  }
  return '';
};

export const packageContainsColor = (state: GlobalState, packageId: number, colorId: number) => {
  const packages = getPackages(state);
  const pack = packages.find(({ id }) => id === packageId);

  if (!pack) {
    return false;
  }

  return !!pack.mapped.colors.find(color => color.id === colorId);
};

export const getCarsFromActivePackage = (state: GlobalState): ?PackageCar[] => {
  const activePackage = getActivePackage(state);
  if (activePackage && activePackage.cars) {
    return activePackage.cars;
  }
  return null;
};

export default null;
